<template>
  <header>
    <img src="../../../assets/logo.svg"/>
  </header>
</template>
<script>
export default {
  
}
</script>